import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { CheckCircle, ErrorOutline } from '@material-ui/icons';
import { PrimaryCheckbox } from '../../components/AtomComponents';
import type { TaskStatus } from './usePxwConnectorConfig';
import type { TaskItem } from './types';

interface ReviewTaskItemProps {
  task: TaskItem;
  enabled: boolean;
  status: TaskStatus;
  errorMsg?: string;
  onRunTask: (taskId: string) => Promise<boolean> | Promise<void>;
  readOnly?: boolean;
}

export const ReviewTaskItem = ({
  task,
  enabled,
  status,
  errorMsg,
  onRunTask,
  readOnly = false,
}: ReviewTaskItemProps) => {
  if (!enabled) {
    return (
      <div className="pxw-review-item pxw-review-item--disabled">
        <div className="pxw-review-main">
          <div className="pxw-review-left">
            <PrimaryCheckbox checked={false} disabled />
            <div>
              <p className="pxw-review-title">{task.title}</p>
              <p className="pxw-review-endpoint">{task.endpoint}</p>
            </div>
          </div>
          <div>
            <span className="pxw-review-status-disabled">Disabled</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pxw-review-item">
      <div className="pxw-review-main">
        <div className="pxw-review-left">
          <PrimaryCheckbox checked={true} readOnly />
          <div>
            <p className="pxw-review-title">{task.title}</p>
            <p className="pxw-review-endpoint">{task.endpoint}</p>
          </div>
        </div>
        <div>
          {readOnly || ((task.id === 'vanilla' || task.id === 'deploy-build') && status === 'success') ? (
            <span className="pxw-review-status-success">
              <CheckCircle className="pxw-review-icon-success" />
              Done
            </span>
          ) : (
            <>
              {status === 'idle' && (
                <button type="button" className="pxw-review-btn-run" onClick={() => onRunTask(task.id)}>
                  Will run
                </button>
              )}
              {status === 'loading' && (
                <span className="pxw-review-status-loading">
                  <CircularProgress size={14} className="pxw-review-spinner" />
                  Running...
                </span>
              )}
              {status === 'success' && (
                <span className="pxw-review-status-success">
                  <CheckCircle className="pxw-review-icon-success" />
                  Done
                </span>
              )}
              {status === 'error' && (
                <button type="button" className="pxw-review-btn-retry" onClick={() => onRunTask(task.id)}>
                  <ErrorOutline className="pxw-review-icon-retry" />
                  Retry
                </button>
              )}
            </>
          )}
        </div>
      </div>
      {status === 'error' && errorMsg && (
        <div className="pxw-review-error-box">Error: {errorMsg}</div>
      )}
    </div>
  );
};
